import React from 'react';
import {
  TradeState,
  TradeViewVariant
} from '../../../../../_shared/types/trade';

import PendingBiddingButtons from './PendingBiddingButtons';
import CurrentNegotiationOffer from './CurrentNegotiationOffer';

import { StyledControls } from '../Styles';
import StyledPendingButtonContainer from './Styles';

const PendingBidBoxFooter = ({ isOmp = false, tradeContext }) => {
  return (
    <>
      <CurrentNegotiationOffer tradeContext={tradeContext} />
      <StyledControls
        variant={TradeViewVariant.VDP}
        tradeState={TradeState.pending}
        tradeContext={tradeContext}
      >
        <StyledPendingButtonContainer>
          <PendingBiddingButtons isOmp={isOmp} tradeContext={tradeContext} />
        </StyledPendingButtonContainer>
      </StyledControls>
    </>
  );
};

export default PendingBidBoxFooter;
